// Shared Stripe.js loader — single promise across the app so we don't
// re-init Stripe on every page mount.
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
let _stripePromise = null;

export function getStripe() {
  if (!_stripePromise && STRIPE_PK) {
    _stripePromise = loadStripe(STRIPE_PK);
  }
  return _stripePromise;
}
